exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".funnel-chart[data-v-8792cd0c] {\n  height: 500px;\n  background-color: #fff;\n}\n", ""]);

// exports
